/*
 * @Author: liushuai 944566598@qq.com
 * @Date: 2023-12-04 10:15:58
 * @LastEditors: liushuai 944566598@qq.com
 * @LastEditTime: 2023-12-13 17:01:43
 * @FilePath: \esg-wenjuandiaocha\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie';
// import store from '@/store/index';
// import {
// 	loginApi
// } from '@/api/api-url/login.js'
// store;
Vue.use(VueRouter)

const routes = [{
		path: '/login',
		name: 'Login',
		component: () => import('../views/login.vue')
	},
	{
		// 问题列表
		path: '/questionList',
		name: 'QuestionList',
		component: () => import('../views/questionList.vue')
	},
	{
		// 答题页面
		path: '/testPage',
		name: 'TestPage',
		component: () => import('../views/testPage.vue')
	},
	{
		// 答题完成页面
		path: '/commitPage',
		name: 'CommitPage',
		component: () => import('../views/commitPage.vue')
	},
	{
		// 完成答题查看页面
		path: '/viewQuestionsPage',
		name: 'ViewQuestionsPage',
		component: () => import('../views/viewQuestionsPage.vue')
	},
	{
		// 后台调过来查看的页面
		path: '/viewQuestions',
		name: 'ViewQuestions',
		component: () => import('../views/viewQuestions/questionList.vue')
	},
	{
		// 后台调过来查看的页面
		path: '/viewQuestionsDetail',
		name: 'ViewQuestionsDetail',
		component: () => import('../views/viewQuestions/viewQuestionDetail.vue')
	},
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})
router.beforeEach(async (to, from, next) => {
	// console.log(to)
	// let arr = document.cookie.split('; '); //通过; 将数据转成数组，注意：分号+空格，有空格！！
	// let AdminToken = '';
	// for (let i = 0; i < arr.length; i++) {
	// 	let ar1 = arr[i].split('=') //返回第一个“=”所在的位置
	// 	if (ar1[0] === "Admin-Token") {
	// 		AdminToken = ar1[1];
	// 		break
	// 	}
	// }
	
	
	if (to.path == '/') {
		next({
			name: 'Login'
		})
		return
	}
	if (to.path == '/login') {
		if(to.query.token){
			Cookies.set('Authorization',to.query.token)
			Cookies.set('companyName', to.query.companyName, {
				expires: 30
			})
			window.sessionStorage.setItem('companyId', to.query.companyId)
			next({
				name: 'ViewQuestions'
			})
			return
		}
		// if(Cookies.get('Authorization')){
		// 	next({
		// 		name: 'QuestionList'
		// 	})
		// }
	}
	if(to.path !== '/login'){
		if(!Cookies.get('Authorization')){
			next({
				name: 'Login'
			})
		}
	}
	

	// if(to.path != '/login'||(to.path == '/login'&&to.query.token)){
	// 	let AdminToken = '';
	// 	if(to.query.token){
	// 		AdminToken = to.query.token;
	// 		Cookies.set('Authorization',to.query.token)
	// 	}
	// 	if(Cookies.get('Authorization')){
	// 		AdminToken = Cookies.get('Authorization')
	// 	}
	// 	if(AdminToken==''){
	// 		next({
	// 			name: 'Login'
	// 		})
	// 		return
	// 	}
	// }



	// console.log(arr)
	// console.log(AdminToken)
	// let isQY = false;//是不是企业账号
	// let isSuperman = false;//是不是超管
	// if (AdminToken && store.state.routesPrivilege.length == 0) {
	// 	store.commit('saveAuthorization', AdminToken);
	// 	// console.log(store)
	// 	if (store.state.routesPrivilege.length == 0) {
	// 		let router = await loginApi.sysUserInfo();
	// 		if (router) {
	// 			store.commit('saveRoutesPrivilege', router.data.menuArr);
	// 			store.commit('saveMenuBtnPrivilege', router.data.pointArr);
	// 			store.commit('saveOrgId', router.data.orgId);
	// 			store.commit('saveOrgCode', router.data.orgCode);
	// 			isSuperman = router.data.isSuperman;
	// 			isQY = router.data.orgCode=='01'?true:false;
	// 			// console.log(store.state)
	// 		}
	// 	}
	// }
	// isSuperman
	// console.log(store.state.routesPrivilege)
	// if(!store.state.routesPrivilege.includes(to.name)&&to.name!='EidHomeProjectEnvironmental'&&!isSuperman){
	// 	return
	// }
	// console.log(isQY)
	
	next()
})
export default router
